<template>
  <main-content class="e-registration-register-success-view">
    <b-card class="e-registration-register-success-view__content">
      <h5>{{ $t("title") }}</h5>
      <p>{{ $t("desc") }}</p>
    </b-card>
  </main-content>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.e-registration-register-success-view {
  &__content {
    position: relative;
    width: 100%;
    top: 15%;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Set Account Password",
    "desc": "Email is sent to your registered email address. Please check your email and set your initial account password by the activation key within 15 minutes in order to complete the registration of your user account."
  },
  "zh_hk": {
    "title": "設定用戶密碼",
    "desc": "系統已發出電郵致你所登記的電郵地址。請查閱電郵，並須於十五分鐘內到使用啟動碼設定你的首個用戶密碼以完成註冊程序。"
  },
  "zh_cn": {
    "title": "设定用户密码",
    "desc": "系统已发出电邮致你所登记的电邮地址。请查阅电邮，并须于十五分钟内到使用启动码设定你的首个用户密码以完成注册程序。"
  }
}
</i18n>
